import * as aiimUtil from "../../aiim/util/aiimUtil";
import * as sourceUtil from "./sourceUtil";

export function readServiceJson(url,target) {
  const promise = new Promise((resolve,reject) => {
    const promises = [];

    aiimUtil.readServiceJson(url).then(result => {

      //console.log("_readServiceJson",result)
      const serviceInfo = result.data;
      target.serviceInfo = serviceInfo;
      serviceInfo.layers.forEach(layer => {
        const id = layer.id;
        const p = aiimUtil.readServiceJson(url+"/"+id);
        promises.push(p);
        p.then(layerResult => {
          const layerInfo = layerResult.data;
          if (sourceUtil.hasPeopleFields(layerInfo,true)) {
            target.peopleLayerInfo = layerInfo;
          } else if (sourceUtil.hasUnitsFields(layerInfo,true)) {
            target.unitsLayerInfo = layerInfo;
          }
          // if (layerInfo.name.toLowerCase() === "people") {
          //   target.peopleLayerInfo = layerInfo;
          // } else if (layerInfo.name.toLowerCase() === "units") {
          //   target.unitsLayerInfo = layerInfo;
          // }
        });
      });
      serviceInfo.tables.forEach(table => {
        const id = table.id;
        const p = aiimUtil.readServiceJson(url+"/"+id);
        promises.push(p);
        p.then(tableResult => {
          //console.log("tableResult",tableResult)
          const tableInfo = tableResult.data;
          if (sourceUtil.hasAreasFields(tableInfo)) {
            target.areasTableInfo = tableInfo;
          }
          // if (tableInfo.name.toLowerCase() === "areas") {
          //   target.areasTableInfo = tableInfo;
          // }
        });
      });

      if (promises.length > 0) {
        return Promise.all(promises);
      }
    }).then(() => {
      resolve();
    }).catch(ex => {
      reject(ex);
    });

  });
  return promise
}
